<template>
  <div class="question">
    <h3>{{this.labelParentel}}</h3>
    <h2 v-html="text"></h2>
    <p class="description" v-show="description && description.length > 0">{{description}}</p>
    <div class="radios">
      <radio-button
        name="test"
        label="Ja"
        :value="true"
        :checked="this.preselect === true"
        @update="$emit('select', true)"
        class="radio"
      />
      <radio-button
        name="test"
        label="Nein"
        :value="false"
        :checked="this.preselect === false"
        @update="$emit('select', false)"
        class="radio"
      />
    </div>
    <div
      v-show="removeButtons !== true"
      class="buttons"
    >
      <unicef-button
        :label="labelPrevOutput"
        :is-pink="true"
        :icon-left="true"
        icon-width="18"
        icon-height="13"
        class="button"
        @press="$router.go(-1)"
      >
        <arrow-left/>
      </unicef-button>
      <unicef-button
        :label="labelNextOutput"
        :is-pink="true"
        icon-width="18"
        icon-height="13"
        class="button"
        @press="$emit('proceed')"
      >
        <arrow-right/>
      </unicef-button>
    </div>
  </div>
</template>

<script>
import ComponentMixin from '@/mixins/ComponentMixin';
import RadioButton from '@/components/RadioButton.vue';
import UnicefButton from '@/components/UnicefButton.vue';
import ArrowLeft from '@/assets/ArrowLeft.vue';
import ArrowRight from '@/assets/ArrowRight.vue';

export default {
  mixins: [ComponentMixin],
  props: {
    preselect: {
      type: Boolean,
    },
    removeButtons: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RadioButton,
    UnicefButton,
    ArrowLeft,
    ArrowRight,
  },
};
</script>

<style scoped></style>
